<template>
  <v-container>
    <v-snackbar centered  timeout="5000" :color="snackbar_color" v-model="snackbar">
      <div class="text-center text-h6">{{ snackbar_text }}</div>
    </v-snackbar>

    <v-card v-if="data && data.zeitpunkt">
      <v-card-title class="primary white--text">Hausbesuch am {{ data.zeitpunkt.substr(0,10) }}</v-card-title>
      <v-card-subtitle class="primary white--text font-weight-bold">Uhrzeit {{ data.zeitpunkt.substr(11,5) }} Uhr</v-card-subtitle>
      <v-card-text>
        <v-card class="mt-3">
          <v-card-title class="text-subtitle-1">Ihre Kontaktdaten</v-card-title>
          <v-card-text>
            <v-row dense no-gutters>
              <v-col cols="4">Name:</v-col>
              <v-col cols="8">{{ data.name }}</v-col>
            </v-row>
            <v-row dense no-gutters>
              <v-col cols="4">Anschrift:</v-col>
              <v-col cols="8">{{ data.strasse }}</v-col>
            </v-row>
            <v-row dense no-gutters>
              <v-col cols="4">Ort:</v-col>
              <v-col cols="8">{{ data.ort }}</v-col>
            </v-row>
            <v-row dense no-gutters>
              <v-col cols="4">Telefon:</v-col>
              <v-col cols="8">{{ data.telefon }}</v-col>
            </v-row>
            <v-row dense no-gutters>
              <v-col cols="4">E-Mail:</v-col>
              <v-col cols="8">{{ data.email }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-form lazy-validation v-model="form_valid" ref="form">
          <v-card class="mt-3">
            <v-card-title class="text-subtitle-1">Allgemeine Angaben</v-card-title>
            <v-card-text><v-textarea dense outlined hide-details label="Allgemeines" v-model="data.bemerkungen"></v-textarea></v-card-text>
            <v-card-title class="text-subtitle-1">Angaben zu den Kindern</v-card-title>
            <v-card-subtitle>Geben Sie hier pro Kind die Daten an:</v-card-subtitle>
            <v-card-text>
              <div class="font-weight-bold text-subtitle-1">Aktelle Anzahl an Kindern: {{ data.angaben.length }}</div>
              <v-btn color="primary" @click="add" block>Kind hinzufügen
                <v-icon right dark>mdi-account-plus</v-icon>
              </v-btn>
              <v-card class="mt-3" v-for="(r,i) of data.angaben" :key="i">
                <v-card-title class="text-subtitle-1">Kind {{ i+1 }}</v-card-title>
                <v-card-text class="pb-0">
                  <v-text-field :rules="[rules.required]" dense outlined label="Name" v-model="r.name"></v-text-field>
                  <v-textarea :rules="[rules.required, rules.counter]" dense outlined label="Positives" v-model="r.positives"></v-textarea>
                  <v-textarea :rules="[rules.required, rules.counter]" dense outlined label="Negatives" v-model="r.negatives"></v-textarea>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="red white--text" @click="data.angaben.splice(i,1)" block>Kind entfernen
                    <v-icon right dark>mdi-account-minus</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="d-block flex-grow-1">
          <div class="text-center text-caption font-weight-normal grey--text">Ihre Daten werden am {{ data.zeitpunkt }} Uhr automatisch gelöscht! Mit dem speichern stimmen sie zu, die Daten bis zum obigen Termin elektronisch zu speichern.</div>
          <div>
            <v-btn :disabled="!speichernOK" color="primary" @click="save" block>Angaben speichern
              <v-icon right dark>mdi-content-save</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="data && data.ID && data.code">
      <v-card-title class="primary white--text">Feedback</v-card-title>
      <v-card-subtitle class="primary white--text">Feedback für unseren Hausbesuch bei Ihnen</v-card-subtitle>
      <v-card-text>
        <div class="text-subtitle-1 mt-4">Hier können Sie Ihr Feedback abgeben:</div>
        <v-textarea dense outlined hide-details v-model="data.feedback"></v-textarea>
      </v-card-text>
      <v-card-actions>
        <div class="d-block flex-grow-1">
          <div>
            <v-btn color="primary" @click="saveFeedback" block>Feedback abgeben
              <v-icon right dark>mdi-content-save</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="loaded && !hasParams">
      <v-card-title class="primary white--text py-2">Hausbesuch anfragen</v-card-title>
      <v-card-text class="text-subtitle-2 pt-4 pb-0 text-center">
        <v-form lazy-validation v-model="form_anfragen_valid" ref="form_anfragen">
          <v-text-field persistent-placeholder :rules="[rules.required]" dense outlined label="Name" v-model="data.name"></v-text-field>
          <v-text-field persistent-placeholder :rules="[rules.required]" placeholder="Straße und Hausnummer" dense outlined label="Anschrift" v-model="data.strasse"></v-text-field>
          <v-text-field persistent-placeholder :rules="[rules.required]" dense outlined label="Ort" v-model="data.ort"></v-text-field>
          <v-text-field persistent-placeholder :rules="[rules.required,rules.telefon]" placeholder="+49 8682 12345678" dense outlined label="Telefon" v-model="data.telefon"></v-text-field>
          <v-text-field persistent-placeholder :rules="[rules.required,rules.email]" placeholder="max@mustermann.de" dense outlined label="E-Mail" v-model="data.email"></v-text-field>
          <v-select persistent-placeholder :rules="[rules.required]" :items="availableTimeSlots" dense outlined label="Wunschzeitpunkt" hint="Eine verfügbare Auswahl bedeutet nicht, dass der Termin noch verfügbar ist" v-model="data.wunschzeitpunkt"></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <div class="d-block flex-grow-1">
          <div class="text-center text-caption font-weight-normal grey--text">Ihre Daten werden am nach dem Termin automatisch gelöscht! Mit dem speichern stimmen sie zu, die Daten bis zum Termin elektronisch zu speichern.</div>
          <div>
            <v-btn :disabled="!anfragenOK" color="primary" @click="anfragen" block>Hausbesuch anfragen</v-btn>
          </div>
        </div>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="loaded">
      <v-card-title class="red white--text">Angaben konnten nicht gefunden werden</v-card-title>
      <v-card-text class="text-subtitle-2 pt-4 text-center">Der angegebene Code ist ungültig.<br /> <br />Bitte wenden sie sich telefonisch an uns!</v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import axios from 'axios';

export default {
  name: 'Hausbesuche-Buchung',
  data: () => ({
    api: "",
    data: {},
    snackbar_color: "green",
    snackbar_text: "",
    snackbar: false,
    loaded: false,
    form_valid:false,
    form_anfragen_valid:false,
    hasParams: false,
    rules: {
      required: value => !!value || 'Angabe erforderlich.',
      counter: value => value.length >= 10 || 'Bitte geben sie mehr an',
      email: value => /.+@.+\..+/.test(value) || 'Bitte eine gültige E-Mail-Adresse eingeben',
      telefon: value => /^\+?[0-9\s]{6,20}$/.test(value) || 'Bitte Telefonnummer im Format "+49 8622 1234567" eingeben',
    },
    tpl: {
      name: "",
      positives: [],
      negatives: []
    }
  }),
  mounted(){
    this.api = process.env.VUE_APP_APIURL
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.hasParams = urlParams.size!=0
    axios.get(this.api+"buchung/get/"+urlParams.get("code"))
      .then((resp) => {
        if (resp.data) this.data = resp.data
      })
      .catch(() => {
          this.snackbar_color = "red"
          this.snackbar_text = "Angaben ungültig!"

      }).finally( () => {
        this.loaded = true
      })

  },
  methods:{
    add(){
      if (this.data.angaben.length<10){
        this.data.angaben.push(Object.assign({},this.tpl))
        setTimeout( () => this.validate() ,10)
      }
    },
    anfragen(){
      axios.post(this.api+'buchung/anfragen/',this.data)
        .then( (resp) => {
          if (resp.data.result){
            this.snackbar_color = "green"
            this.snackbar_text = "Angaben gespeichert"
          }else{
            this.snackbar_color = "red"
            this.snackbar_text = "FEHLER beim speichern"
          }
          this.snackbar = true
        })
    },
    save(){
      axios.post(this.api+'buchung/save/',this.data)
        .then( (resp) => {
          if (resp.data.result){
            this.snackbar_color = "green"
            this.snackbar_text = "Angaben gespeichert"
          }else{
            this.snackbar_color = "red"
            this.snackbar_text = "FEHLER beim speichern"
          }
          this.snackbar = true
        })
    },
    saveFeedback(){
      axios.post(this.api+'buchung/saveFeedback/',this.data)
        .then( (resp) => {
          if (resp.data.result){
            this.snackbar_color = "green"
            this.snackbar_text = "Feedback gespeichert, vielen Dank"
            setTimeout(() => { document.location.href='https://www.perchten.net'},4000)
          }else{
            this.snackbar_color = "red"
            this.snackbar_text = "FEHLER beim speichern des Feedbacks"
          }
          this.snackbar = true
        })
    },
    validate(){
        if (this.$refs && this.$refs.form) return this.$refs.form.validate()
        return false
    },
    validate_anfragen(){
        if (this.$refs && this.$refs.form_anfragen) return this.$refs.form_anfragen.validate()
        return false
    },
  },
  computed:{
    availableTimeSlots() {
      const currentYear = new Date().getFullYear(); // Ermittelt das aktuelle Jahr
      const timeSlots = [];

      // Funktion zum Hinzufügen von Zeitfenstern für einen bestimmten Tag
      const addTimeSlotsForDay = (day) => {
        for (let hour = 16; hour <= 20; hour++) {
          const formattedDay = String(day).padStart(2, '0');
          const formattedMonth = '12'; // Dezember ist der 12. Monat
          const formattedHour = String(hour).padStart(2, '0');

          timeSlots.push({
            text: `${formattedDay}.${formattedMonth}.${currentYear} ${formattedHour}:00`,
            value: `${currentYear}-${formattedMonth}-${formattedDay} ${formattedHour}:00:00`
          });

          timeSlots.push({
            text: `${formattedDay}.${formattedMonth}.${currentYear} ${formattedHour}:30`,
            value: `${currentYear}-${formattedMonth}-${formattedDay} ${formattedHour}:30:00`
          });
        }
      };

      // Zeitfenster für den 5. Dezember hinzufügen
      addTimeSlotsForDay(5);

      // Zeitfenster für den 6. Dezember hinzufügen
      addTimeSlotsForDay(6);

      return timeSlots;
    },
    speichernOK: function(){
      if (!this.data.angaben){
        return false
      }
      if (this.data.angaben.length<=0){
        return false
      }
      return this.form_valid
    },
    anfragenOK: function(){
      if (!this.data.email || !this.data.wunschzeitpunkt){
        return false
      }
      return this.form_anfragen_valid
    }
  }
}
</script>
